import React from 'react';
import { Link } from 'react-router-dom';
import './loan-calculator.css';
import './key-features.css';
import featureImg from '../assets/images/feature-img.png';
import {
  ScrollReveal,
  ScrollRevealStagger,
  ScrollRevealItem,
} from './ScrollReveal';
import {
  Zap,
  FileCheck,
  CalendarRange,
  Wallet,
  ShieldCheck,
  Headphones,
} from 'lucide-react';

const features = [
  {
    icon: Zap,
    title: 'Instant approval',
    desc: 'Digital checks help you get a decision in minutes.',
  },
  {
    icon: FileCheck,
    title: 'Paperless KYC',
    desc: 'Upload documents from your phone — no branch visit.',
  },
  {
    icon: CalendarRange,
    title: 'Flexible tenure',
    desc: 'Repay comfortably between 7 and 365 days.',
  },
  {
    icon: Wallet,
    title: 'Max ₹1,00,000',
    desc: 'We do not sanction loans above ₹1 lakh — amount based on your profile.',
  },
  {
    icon: ShieldCheck,
    title: 'Secure platform',
    desc: '256-bit encryption protects your personal data.',
  },
  {
    icon: Headphones,
    title: 'Dedicated support',
    desc: 'Guidance from apply to disbursal and repayment.',
  },
];

const KeyFeatures = () => {
  return (
    <section className="kf-section" id="key-features">
      <div className="lc-bg" aria-hidden="true">
        <div className="lc-bg-gradient" />
        <div className="lc-bg-mesh" />
        <div className="lc-bg-dots" />
        <span className="lc-bg-orb lc-bg-orb--1" />
        <span className="lc-bg-orb lc-bg-orb--2" />
        <span className="lc-bg-orb lc-bg-orb--3" />
      </div>

      <div className="kf-container">
        <ScrollReveal className="kf-panel" y={40}>
          <aside className="kf-aside" aria-label="MR Rupya customer">
            <div className="kf-aside-decor" aria-hidden="true">
              <span className="kf-aside-blob" />
              <span className="kf-aside-ring" />
            </div>

            <div className="kf-aside-img-wrap">
              <div className="kf-aside-head">
                <span className="kf-aside-brand">MR RUPYA</span>
                <p className="kf-aside-tagline">
                  Your loan journey,
                  <span> made simple.</span>
                </p>
              </div>
              <img
                src={featureImg}
                alt="Happy MR Rupya customer"
                className="kf-aside-img"
                width={666}
                height={374}
                loading="lazy"
                draggable={false}
              />
            </div>

            <ul className="kf-aside-pills">
              <li>Max ₹1,00,000</li>
              <li>7–365 days</li>
              <li>100% digital</li>
            </ul>
          </aside>

          <div className="kf-main">
            <span className="kf-eyebrow">Key features</span>
            <h2 className="kf-heading">
              Everything you need for a
              <span> stress-free loan</span>
            </h2>
            <p className="kf-subtext">
              Built for salaried professionals — fast verification, clear
              terms, and support at every step.
            </p>

            <ScrollRevealStagger as="ul" className="kf-list" stagger={0.08}>
              {features.map((item) => {
                const Icon = item.icon;
                return (
                  <ScrollRevealItem
                    key={item.title}
                    as="li"
                    className="kf-list-item"
                  >
                    <span className="kf-list-icon" aria-hidden="true">
                      <Icon size={18} strokeWidth={2} />
                    </span>
                    <div className="kf-list-text">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </ScrollRevealItem>
                );
              })}
            </ScrollRevealStagger>

            <ScrollReveal delay={0.2} y={20}>
              <div className="kf-actions">
                <Link to="/apply-now" className="kf-btn kf-btn-fill">
                  Apply for loan
                </Link>
              </div>
            </ScrollReveal>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default KeyFeatures;
